import React from "react";
import "./LeaderAdvisorySection.css";

const LeaderAdvisorySection = ({
  titleLine1 = "100K-1M low Cross",
  titleLine2 = "Functional Advisors",
  description = "Our advisory board includes seasoned experts in law, communications, strategy, and human capital who bring perspective, governance, and stability to our leadership table.",
  buttonText = "Meet the Team",
  onButtonClick
}) => {
  return (
    <div className="advisory-wrapper">
      <section className="advisory-section">
        <div className="advisory-left">
          <div className="vertical-line"></div>
          <div className="advisory-title">
            <h2>{titleLine1}</h2>
            <h2>{titleLine2}</h2>
          </div>
        </div>
        <div className="advisory-right">
          <p>{description}</p>
          <button
            className="explore-btn"
            onClick={onButtonClick}
          >
            {buttonText}
          </button>
        </div>
      </section>
    </div>
  );
};

export default LeaderAdvisorySection;

